import { Component } from "react";
import { Link } from "react-router-dom";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("Page error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 px-4 pt-20 text-center" data-testid="error-boundary">
          <p className="font-mono text-sm text-rw-green">Something didn't load correctly</p>
          <h1 className="font-jakarta text-2xl sm:text-3xl font-extrabold text-rw-text">This page hit a snag.</h1>
          <p className="max-w-md text-sm text-rw-muted">A quick refresh usually fixes it.</p>
          <div className="flex gap-4">
            <button onClick={() => window.location.reload()} data-testid="error-reload-button"
              className="rounded-full bg-rw-green px-6 py-3 text-sm font-semibold text-rw-bg hover:bg-rw-green2 transition-colors">
              Reload Page
            </button>
            <Link to="/" className="rounded-full border border-rw-border2 px-6 py-3 text-sm font-semibold text-rw-text hover:border-rw-green/60 hover:text-rw-green transition-all">
              Go Home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
